import { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SeoHead from '../seo/SeoHead';
import { PAGES, BUSINESS, SITE_URL } from '../seo/businessConfig';
import { pageBreadcrumbs } from '../seo/schema';

function NaszaHistoria() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const page = PAGES.historia;
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: page.title,
    description: page.description,
    url: `${SITE_URL}/nasza_historia`,
    about: { '@id': `${SITE_URL}/#business` },
    inLanguage: 'pl-PL',
    dateModified: '2026-10-03',
  };

  return (
    <div className="relative bg-primary-olive min-h-screen">
      <SeoHead
        title={page.title}
        description={page.description}
        keywords={page.keywords}
        path={page.path}
        jsonLd={[pageBreadcrumbs('historia'), articleSchema]}
      />
      <Navbar />

      <main className="pt-32 md:pt-48 pb-20 px-6 md:px-12 max-w-5xl mx-auto">
        <header className="mb-12 md:mb-20">
          <h1 className="text-5xl md:text-7xl font-bold text-primary tracking-wide">
            Nasza Historia
            <span className="text-primary opacity-50">/</span>
          </h1>
          <p className="mt-4 text-primary text-lg md:text-xl max-w-2xl leading-relaxed">
            Pensjonat Zacisze Czarna Owca w Brzeżance — historia miejsca na mapie Podkarpacia.
          </p>
        </header>

        <article className="bg-primary-bright bg-opacity-40 p-8 md:p-12 lg:p-16 rounded-xl shadow-lg text-primary text-lg md:text-xl leading-relaxed md:leading-loose space-y-6 md:space-y-8 font-medium">
          <p>
            Nasza przygoda rozpoczęła się wiele lat temu, kiedy marzenie o stworzeniu miejsca,
            gdzie ludzie mogliby odnaleźć spokój i bliskość natury, stało się rzeczywistością.
            Zainspirowani pięknem okolicznych krajobrazów i ciepłem lokalnej społeczności,
            postanowiliśmy przekształcić starą posiadłość w pensjonat, który łączy tradycję z
            nowoczesnym komfortem.
          </p>
          <p>
            Każdy kąt naszego pensjonatu ma swoją historię, od starych fotografii na ścianach, po
            meble i sprzęty użytkowe. Nasze serce wkładamy w to, aby każdy gość czuł się jak w domu,
            otoczony opieką i serdecznością.
          </p>
          <p>
            Dziś, po latach pracy i zaangażowania, jesteśmy dumni z tego, że nasze miejsce stało
            się przystanią dla tych, którzy szukają autentycznych doświadczeń i prawdziwego
            wypoczynku. Nasza historia to opowieść o pasji, miłości do natury i pragnieniu dzielenia się
            tym, co najpiękniejsze.
          </p>
          <p>
            Jeśli chcecie Państwo miło, przyjemnie, w ładnym otoczeniu i tanio spędzić rodzinny
            urlop, wypoczynek, jeśli chcecie zorganizować imprezę integracyjną w klimacie jak w
            Bieszczadach, serdecznie zapraszamy!
          </p>
          <p>
            Nasze „Zacisze” chce być dla Państwa gwarantem wspaniałego pobytu w
            atrakcyjnym przyrodniczo terenie, w połączeniu z aktywnością fizyczną. Usytuowanie
            pensjonatu daje poczucie przebywania w enklawie ciszy i spokoju, z dala od siedzib
            ludzkich.
          </p>
          <p>
            Miejscowość Brzeżanka, oddalona o około 5 km od powiatowego miasta
            Strzyżowa, daje namiastkę uroku Bieszczadów, w tak niedalekim sąsiedztwie od Rzeszowa.
            Czyste powietrze, wspaniałe pogórze z Czarnorzecko-Strzyżowskim Parkiem
            Krajobrazowym, obfitość grzybów w lasach, infrastruktura dróg, duktów leśnych i polnych
            dają możliwość niezapomnianego wypoczynku.
          </p>
          <p>
            Zapraszamy do {BUSINESS.legalName}, {BUSINESS.address.streetAddress},{' '}
            {BUSINESS.address.postalCode} {BUSINESS.address.cityForSearch}. Tel.{' '}
            {BUSINESS.telephoneDisplay}.
          </p>

          <div className="pt-8 mt-8 border-t border-primary border-opacity-20">
            <p className="text-2xl md:text-4xl font-bold text-primary leading-tight text-center italic">
              Serdecznie zapraszamy do odkrycia jej razem z nami.
            </p>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}

export default NaszaHistoria;
